module.exports = __webpack_public_path__ + "media/dog.7040b3e9.mp3";